import { GameVars } from "../GameVars";
import { AudioManager } from "../managers/AudioManager";
import { Ad } from "./Ad";

export class GDAd implements Ad {
    public rewardedAdReady: boolean = false;
    private soundAlreadyMuted: boolean;
    private musicAlreadyMuted: boolean;

    private currentCallback: (success: boolean) => void;
    private callbackContext: any;


    init(): void {
        window.advertisement = this;
    }

    showAd(callback: (success: boolean) => void, context: any) {
        this.currentCallback = callback;
        this.callbackContext = context;
        console.log("SHOWING AD");
        window.gdsdk.showAd().then(() => {
            console.log("SHOW AD DONE");
            this.currentCallback.call(this.callbackContext, true);
            this.currentCallback = null;
            this.callbackContext = null;
        });
    }

    loadRewardedAd() {
        if (this.rewardedAdReady) {
            return;
        }
        window.gdsdk.preloadAd("rewarded").then(() => {
            console.log("REWARDED AD READY");
            this.rewardedAdReady = true;
        }).catch(() => {
            this.rewardedAdReady = false;
        });
    }

    isRewardedAdReady(): boolean {
        return this.rewardedAdReady;
    }
    showRewardedAd(callback: (success: boolean) => void, context: any) {
        this.currentCallback = callback;
        this.callbackContext = context;
        console.log("REWARDED AD");
        if (!this.rewardedAdReady) {
            this.error();
            return;
        }
        this.rewardedAdReady = false;
        window.gdsdk.showAd("rewarded").then(() => {
            this.currentCallback.call(this.callbackContext, true);
            this.currentCallback = null;
            this.callbackContext = null;
            this.loadRewardedAd();
        }).catch(() => {
            this.currentCallback.call(this.callbackContext, false);
            this.currentCallback = null;
            this.callbackContext = null;
            this.loadRewardedAd();
        });
    }

    error() {
        if (this.currentCallback) {
            this.currentCallback.call(this.callbackContext, false);
        }
        this.currentCallback = null;
        this.callbackContext = null;
    }

    pauseAndMuteGame() {
        this.musicAlreadyMuted = GameVars.gameData.muted;
        this.soundAlreadyMuted = GameVars.gameData.muted;
        AudioManager.mute();
        GameVars.paused = true;
    }

    resumeAndUnmuteGame() {
        GameVars.paused = false;
        if (!this.musicAlreadyMuted) {
            AudioManager.unmute();
        }
        if (!this.soundAlreadyMuted) {
            AudioManager.unmute();
        }
    }
}